import { ChangeDetectionStrategy, Component } from '@angular/core';
import { O2OOrderViewComponent } from '../../../o2o/view/o2o-order-view.component';
import { getStandardSalesOrderViewConfig } from '../internal.config';

@Component({
  selector: 'app-standard-order-view',
  standalone: true,
  imports: [O2OOrderViewComponent],
  templateUrl: './standard-order-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardOrderViewComponent {
  readonly createConfigFactory = getStandardSalesOrderViewConfig;
}
